/*
 * FOR SALE — tickets depuis la fiche et lien de paiement de l'équipe (décision 012). Module chargé seulement si le
 * réglage tickets_enabled est actif et le service valide (racine [data-fs-tickets="<service>"] : accueil ou page d'une
 * annonce), APRÈS fs-account.js : session, connexion Discord, /me et appels au service passent par window.FSAccount
 * (session commune à tout le site et aux onglets).
 *
 * Fiche ([data-fs-ld], dans [data-fs-detail] : dialogue de l'accueil ou page /pages/listings/<handle>) — zone commerce :
 * une action de ticket, une ligne d'état ([data-fs-ticket-slot]) vide tant qu'il n'y a rien à dire (aucune explication
 * du ticket, demande de Charles du 9 octobre 2026), erreurs dans une alerte. Avec « Acheter ce compte » (achat direct),
 * l'action de ticket est secondaire et se place sous la zone commerce ([.fs-ld-ask], hors de la bande collante du
 * téléphone) ; sinon elle est l'action principale de la zone commerce.
 *  - sans ticket pour l'annonce : « Demander un renseignement » (POST /tickets { listing }) ; sans session, connexion
 *    Discord (intention « ticket » gardée par fs-account.js), puis ticket ouvert sans nouveau clic au retour ;
 *  - un seul ticket par client et par annonce, renseignement ou achat (GET /tickets/mine, lu une fois par minute et par
 *    session ; le service rend aussi le ticket existant à un second POST /tickets) : « Continuer dans mon ticket ↗ »
 *    (salon Discord, ouvert dans l'application par fs-discord-link.js), état et date ; jamais un second bouton d'ouverture ;
 *  - ticket fermé par l'équipe (décision 013 : jamais recréé depuis le site) : « Voir mon ticket ↗ » pour le relire, sans
 *    nouveau renseignement ; salon supprimé : ligne d'état seule ;
 *  - jeu sans catégorie de tickets (DarkOrbit) : aucune action de ticket, une ligne d'état le dit ; l'achat direct reste ;
 *  - compte hors du serveur : ajouté au serveur à la connexion si le service l'annonce (GET /features → join : seule
 *    ligne gardée sans ticket, très courte), sinon erreur au retour avec le lien d'invitation (réglage
 *    discord_invite_url) ; service indisponible : message d'erreur, réessayer plus tard.
 *  L'achat et le renseignement restent sur le site (P-14, P-21) : jamais de lien Discord de l'annonce comme action ni
 *  comme repli. Module inactif (service ou fs-account.js absents) : la phrase [data-fs-ld-nolink] de la fiche réapparaît.
 *  - annonce d'exemple (fiche ou un de ses éléments [data-fs-sample], source showcase-v1) : rien n'est monté — ni bouton
 *    ticket, ni « Aller à mon ticket », ni ligne d'état, ni panneau de l'équipe —, même si la fiche porte un jour un
 *    emplacement de ticket (isSample, ticketable) ; le service la refuse aussi (409 listing_not_ticketable).
 *
 * Équipe (hors de ce module : barre « Modifier l'annonce » de la page d'une annonce, fs-listing-admin.js) : rien de plus
 * sur la fiche, sauf arrivée par le lien ?ticket= de la carte de suivi : « Gérer dans l'espace équipe »
 * (ou « Équipe FOR SALE : se connecter » sans session) dans [data-fs-ticket-admin]. Fonctions d'avant pour le panneau
 * (GET /me → features.payments, ou staff avec les tickets : MiddleMan), gardées pour les tests et l'espace équipe. Dossiers
 * de l'annonce (acheteur, badge d'état, emplacement du salon, « Pris en charge », lien de paiement, dernier événement,
 * salon Discord), dossier présélectionné par ?ticket=<dossier> (lien posté dans le ticket, sur l'accueil comme sur la
 * page de l'annonce) ou par l'intention gardée pendant la connexion. Pour le dossier choisi : boutons des actions
 * permises par le service (`actions` de GET /tickets, rien n'est recalculé ici), gestion du ticket d'un côté, paiement
 * et vente de l'autre ; POST /tickets/actions, occupé pendant l'appel, message dans une zone role="status", dossier
 * remplacé par la réponse ; conflit (état changé depuis Discord) : dossiers relus. Conclure demande une confirmation,
 * supprimer le salon la saisie de SUPPRIMER. Dossiers relus au retour sur l'onglet (visibilitychange, 15 s au moins
 * entre deux lectures, aucun sondage). Lien ouvert dans un champ copiable, montant et devise alignés, historique replié
 * en tableau. ?ticket= sans session : « Équipe FOR SALE : se connecter ».
 * Aucun prix n'est jamais montré à un visiteur ; tout texte venu du service passe par textContent, toute adresse est
 * vérifiée (Discord, admin Shopify, lien https de paiement). Les fonctions pures sont exportées pour les tests Node.
 * Textes du visiteur dans la langue de la page (fs-i18n.js, zone ticket de i18n/) ; ce que seul l'espace équipe affiche
 * (étapes, emplacements, actions, événements, liens de paiement, issues des actions) reste en français (décision INTL).
 */
import { el as h } from './fs-ui.js';
import { t, date, path } from './fs-i18n.js';

/** Événement interne à la fiche : un ticket vient d'y être ouvert (le panneau de l'équipe relit ses dossiers). */
export const TICKET_OPENED_EVENT = 'fs:ticket-opened';
/** Jeux dont la demande s'ouvre depuis la fiche (décision 012) : les jeux à catégorie « Buying » du service, plus DarkOrbit,
 *  ticketable par le rangement par étape (décision 026, TICKET_STAGES). Un jeu fermé au public par le thème
 *  (window.FSComingSoonGames, fs-game-access.liquid, réglage fs_darkorbit_live) reste exclu : voir ticketGameOpen. */
export const TICKET_GAMES = Object.freeze(['waruniverse', 'redgalaxy', 'darkorbit', 'novahorizon']);
/** Jeu de TICKET_GAMES ouvert au public. Sans fs-game-access (page sans le snippet, tests sous Node) : DarkOrbit fermé,
 *  comme for-sale.js et for-sale-catalog-view.js. */
export function ticketGameOpen(game) {
  return TICKET_GAMES.includes(game) && !(globalThis.FSComingSoonGames ?? ['darkorbit']).includes(game);
}
export const HANDLE = /^[a-z0-9][a-z0-9-]{0,99}$/;
export const TICKET = /^ticket-[0-9a-f]{16}$/;
/** Durée de validité de la liste « mes tickets » lue pour les fiches (une lecture pour toutes les fiches ouvertes). */
export const MINE_TTL_MS = 60_000;

/** État d'un dossier → libellé et ton du badge (mêmes valeurs que TICKET_STATUS de fs-account.js). */
export const DEAL_STATUS = Object.freeze({
  open: { label: t('ticket.status.open'), tone: 'accent' },
  link_sent: { label: t('ticket.status.link_sent'), tone: 'warn' },
  ordered: { label: t('ticket.status.ordered'), tone: 'warn' },
  paid: { label: t('ticket.status.paid'), tone: 'ok' },
  sold: { label: t('ticket.status.sold'), tone: 'ok' },
  closed: { label: t('ticket.status.closed'), tone: 'muted' },
});
/** Étape du dossier dans le panneau de l'équipe (en français) : « Ticket ouvert » y deviendrait ambigu à côté de
 *  l'emplacement (salon fermé, étape ouverte) ; les autres étapes reprennent les libellés français de DEAL_STATUS. */
export const STEP_STATUS = Object.freeze({
  open: { label: 'En discussion', tone: 'accent' },
  link_sent: { label: 'Lien de paiement envoyé', tone: 'warn' },
  ordered: { label: 'Paiement en attente', tone: 'warn' },
  paid: { label: 'Payé', tone: 'ok' },
  sold: { label: 'Vendu', tone: 'ok' },
  closed: { label: 'Clos', tone: 'muted' },
});
/** Emplacement du salon sur Discord (catégorie « Buying », « Ticket Pending », « Closed », ou salon supprimé). */
export const LOCATION = Object.freeze({
  open: { label: 'Ouvert', tone: 'accent' },
  pending: { label: 'En attente', tone: 'warn' },
  closed: { label: 'Fermé', tone: 'muted' },
  deleted: { label: 'Salon supprimé', tone: 'danger' },
});
/**
 * Actions de ticket que le panneau sait afficher (les mêmes boutons que la carte de suivi sur Discord). L'ordre des clés
 * est l'ordre d'affichage ; `group` : gestion du ticket ou paiement et vente ; `confirm` : simple ou saisie de SUPPRIMER.
 * Le service seul décide des droits : le panneau n'affiche que les actions de `actions`, sans rien recalculer.
 */
export const TICKET_ACTIONS = Object.freeze({
  claim: { label: 'Prendre en charge', group: 'ticket' },
  unclaim: { label: 'Libérer', group: 'ticket' },
  pending: { label: 'Mettre en attente', group: 'ticket' },
  reopen: { label: 'Rouvrir', group: 'ticket' },
  close: { label: 'Fermer le ticket', group: 'ticket' },
  delete: { label: 'Supprimer le ticket', group: 'ticket', confirm: 'typed', danger: true },
  conclude: { label: 'Conclure la vente', group: 'sale', confirm: 'simple' },
});
/** Actions de paiement, servies par POST /payment-links et /payment-links/cancel (formulaire et lien ouvert du panneau). */
export const PAYMENT_ACTIONS = Object.freeze({ create: 'payment_link', cancel: 'cancel_link' });
/** Mot à saisir pour supprimer un salon. */
export const DELETE_WORD = 'SUPPRIMER';
/** Dernier événement d'un dossier → libellé au passé (actions du panneau, de Discord et du service). */
export const EVENT_LABELS = Object.freeze({
  open: 'Ticket ouvert', claim: 'Pris en charge', unclaim: 'Libéré', pending: 'Mis en attente', close: 'Fermé', reopen: 'Rouvert',
  conclude: 'Vente conclue', delete: 'Salon supprimé', payment_link: 'Lien de paiement envoyé', cancel_link: 'Lien de paiement annulé', link_replaced: 'Lien de paiement remplacé',
  link_deleted: 'Lien supprimé dans Shopify', ordered: 'Commande créée', paid: 'Paiement reçu',
});
/** GET /features → join (ajout au serveur à la connexion), gardé 5 min dans l'onglet : une lecture pour toutes les pages
 *  visitées, pas une par page (le service limite chaque IP à 60 appels par minute). */
export const JOIN_KEY = 'fs-ticket-join';
export const JOIN_TTL_MS = 5 * 60 * 1000;
/** Cache d'onglet { at, join } : `join` (booléen) s'il a moins de 5 min, sinon null. */
export function readJoinCache(raw, now = Date.now()) {
  try {
    const cache = JSON.parse(raw || 'null');
    if (!cache || typeof cache.join !== 'boolean' || !Number.isFinite(cache.at) || cache.at > now + 1000 || now - cache.at >= JOIN_TTL_MS) return null;
    return cache.join;
  } catch { return null; }
}
/** Relecture du panneau au retour sur l'onglet (actions faites depuis Discord) : au plus une lecture toutes les 15 s. */
export const REFRESH_MIN_MS = 15_000;
/** État d'un lien de paiement → libellé et ton. */
export const LINK_STATUS = Object.freeze({
  open: { label: 'Ouvert', tone: 'accent' },
  ordered: { label: 'Paiement en attente', tone: 'warn' },
  paid: { label: 'Payé', tone: 'ok' },
  replaced: { label: 'Remplacé', tone: 'muted' },
  cancelled: { label: 'Annulé', tone: 'muted' },
  deleted: { label: 'Supprimé dans Shopify', tone: 'danger' },
});
/** Dossiers terminés côté paiement, vendus ou clos : aucun nouveau lien depuis le panneau. */
const SETTLED = new Set(['ordered', 'paid', 'sold', 'closed']);

/** URL de base du service : https (ou http local de développement), sans identifiants, requête ni / final. */
export function serviceBase(raw) {
  try {
    const url = new URL(String(raw || '').trim());
    const local = url.protocol === 'http:' && ['127.0.0.1', 'localhost'].includes(url.hostname);
    if ((url.protocol !== 'https:' && !local) || url.username || url.password || url.search || url.hash) return '';
    return `${url.origin}${url.pathname.replace(/\/+$/, '')}`;
  } catch { return ''; }
}

/** Annonce d'exemple (source showcase-v1) : la fiche ou un de ses éléments porte [data-fs-sample] (à ne pas confondre avec
 *  [data-fs-showcase], la vitrine des designs). Jamais de ticket, de lien « Aller à mon ticket » ni de panneau de l'équipe. */
export const isSample = (detail) => Boolean(detail && (detail.hasAttribute('data-fs-sample') || detail.querySelector('[data-fs-sample]')));

/**
 * Fiche qui peut recevoir « Demander un renseignement » : pas une annonce d'exemple, handle valide, jeu des tickets
 * ouvert au public (ticketGameOpen).
 * `detail` et `slot` : éléments DOM (ou équivalents des tests).
 */
export function ticketable(detail, slot) {
  if (!detail || !slot || isSample(detail)) return false;
  return HANDLE.test(slot.dataset?.fsTicketListing || '') && ticketGameOpen(slot.dataset?.fsTicketGame);
}

/** Fil ou salon Discord du serveur (https://discord.com/channels/<serveur>/<salon>[/<message>]), sinon ''. */
export function discordUrl(raw) {
  const text = String(raw || '').trim();
  return /^https:\/\/discord\.com\/channels\/\d{17,20}\/\d{17,20}(?:\/\d{17,20})?$/.test(text) ? text : '';
}

/** Invitation au serveur (discord.gg/<code> ou discord.com/invite/<code>), sinon ''. */
export function inviteUrl(raw) {
  const text = String(raw || '').trim();
  return /^https:\/\/(?:discord\.gg|discord\.com\/invite)\/[A-Za-z0-9-]{2,64}\/?$/.test(text) ? text : '';
}

/** Page de l'admin Shopify (brouillon, commande), sinon ''. */
export function adminUrl(raw) {
  const text = String(raw || '').trim();
  return /^https:\/\/admin\.shopify\.com\/store\/[a-z0-9-]{1,60}\/(?:draft_orders|orders)\/\d{1,20}$/.test(text) ? text : '';
}

/** Lien de paiement (commande provisoire) : https seulement, sans identifiants. */
export function invoiceUrl(raw) {
  try {
    const url = new URL(String(raw || '').trim());
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}

/**
 * Message d'un retour de connexion refusé (#fs_error=… ou échange refusé), dans le contexte du ticket. Code refusé par
 * Discord, scope manquant ou Discord injoignable : « n'a pas abouti » ; « expiré » seulement pour une demande expirée
 * (state) ou un code de retour perdu. server_limit : compte déjà sur 100 serveurs, l'ajout au serveur est impossible.
 */
export function authReturnMessage(code) {
  const text = String(code || '').toLowerCase();
  if (/restricted|timeout|pending/.test(text)) return t('account.auth.restricted');
  if (/server_limit/.test(text)) return t('ticket.auth.server_limit');
  if (/member/.test(text)) return t('ticket.auth.member');
  if (/denied/.test(text)) return t('ticket.auth.denied');
  if (/exchange|invalid_code|scope|unavailable/.test(text)) return t('ticket.auth.failed');
  return t('ticket.auth.expired');
}

/**
 * Réponse de POST /tickets → { kind, message, url? }. kind : opened | existing | auth | member | closed | unavailable |
 * limit | disabled | error. Aucun repli vers Discord : le visiteur réessaie depuis la fiche.
 */
export function ticketOutcome(status, body) {
  const data = body && typeof body === 'object' ? body : {};
  const url = discordUrl(data.url);
  if ((status === 201 || status === 200) && url) {
    return data.created === false || status === 200
      ? { kind: 'existing', url, message: t('ticket.outcome.existing') }
      : { kind: 'opened', url, message: t('ticket.outcome.opened') };
  }
  /* Message choisi par le code d'erreur du service, jamais par son texte ; repli générique. */
  const code = typeof data.error === 'string' ? data.error : '';
  const say = (key) => t(`ticket.outcome.${key}`);
  if (status === 401) return { kind: 'auth', message: t('ticket.auth.reconnecting') };
  if (status === 403 && code === 'member_restricted') return { kind: 'member', restricted: true, message: authReturnMessage('member_restricted') };
  if (status === 403) return { kind: 'member', message: t('ticket.auth.member') };
  if (status === 409 && code === 'ticket_closed') return { kind: 'closed', message: say('closed') };
  if (status === 409 && code === 'game_not_supported') return { kind: 'disabled', message: UNSUPPORTED_LINE };
  if (status === 409 && code === 'listing_not_ticketable') return { kind: 'unavailable', message: say('sample') };
  if (status === 409 || status === 422) return { kind: 'unavailable', message: say('unavailable') };
  if (status === 429 && code === 'busy') return { kind: 'limit', message: say('busy') };
  if (status === 429) return { kind: 'limit', message: say('limit') };
  if (status === 503 && code === 'tickets_disabled') return { kind: 'disabled', message: say('disabled') };
  return { kind: 'error', message: say('error') };
}

/** Date de l'espace équipe, en français (« 07/10/2026 14:02 »), '' si illisible. */
export function formatDate(iso, options = { dateStyle: 'short', timeStyle: 'short' }) {
  const time = Date.parse(iso || '');
  if (!Number.isFinite(time)) return '';
  return new Intl.DateTimeFormat('fr-FR', options).format(time);
}
/** Date d'un ticket montrée au visiteur, dans la langue de la page. */
const visitorDate = (iso) => (Number.isFinite(Date.parse(iso || '')) ? date(Date.parse(iso), { dateStyle: 'short' }) : '');

/** GET /tickets/mine → le ticket de l'acheteur pour cette annonce { ticket, status, location, url, openedAt } (le plus récent), ou null. */
export function myTicketFor(body, listing) {
  const list = Array.isArray(body?.tickets) ? body.tickets : [];
  const found = list.filter((item) => item && item.listing === listing && TICKET.test(item.ticket ?? ''))
    .sort((a, b) => String(b.openedAt ?? '').localeCompare(String(a.openedAt ?? '')))[0];
  if (!found) return null;
  const location = ['open', 'pending', 'closed', 'deleted'].includes(found.location) ? found.location : 'open';
  return { ticket: found.ticket, status: DEAL_STATUS[found.status] ? found.status : 'open', location, url: location === 'deleted' ? '' : discordUrl(found.url), openedAt: found.openedAt ?? '' };
}

/** Jeu hors des tickets, ou refusé par le service (game_not_supported) : la demande reste sur le site, elle n'y est simplement pas encore ouverte. */
export const UNSUPPORTED_LINE = t('ticket.line.unsupported');

/**
 * Zone commerce de la fiche : une action et une ligne d'état (badge facultatif ; ligne vide : rien n'est affiché).
 * action : 'open' (« Demander un renseignement ») | 'go' (« Continuer dans mon ticket ↗ », url) | 'read' (« Voir mon
 * ticket ↗ », url : ticket fermé, à relire) | 'none' (aucune action de ticket : la ligne d'état seule).
 * Un ticket existant pour l'annonce ne propose jamais d'en ouvrir un autre (un seul ticket par client et par annonce).
 */
export function commerceState({ supported = true, signedIn = false, mine = null, join = false } = {}) {
  if (!supported) return { action: 'none', badge: null, line: UNSUPPORTED_LINE };
  const opened = mine?.openedAt ? visitorDate(mine.openedAt) : '';
  /* « Votre ticket » ou « Votre ticket du … » : clé « _on » quand la date est connue. */
  const dated = (key) => (opened ? t(`ticket.line.${key}_on`, { date: opened }) : t(`ticket.line.${key}`));
  // Salon supprimé par l'équipe (décision 013) : jamais de lien vers un salon disparu, jamais de nouveau ticket depuis le site.
  if (mine?.location === 'deleted') return { action: 'none', url: '', badge: DEAL_STATUS.closed, line: dated('deleted') };
  // Dossier clos ou salon fermé par l'équipe (décision 013 : jamais rouvert depuis le site, 409 ticket_closed) : le salon
  // reste lisible ; aucun nouveau renseignement.
  if (mine?.status === 'closed' || mine?.location === 'closed') {
    const sold = mine.status === 'sold';
    const line = dated(mine.url ? 'closed_read' : 'closed');
    return { action: mine.url ? 'read' : 'none', url: mine.url || '', badge: sold ? DEAL_STATUS.sold : DEAL_STATUS.closed, line: sold ? `${t('ticket.line.sold_prefix')} ${line}` : line };
  }
  if (mine?.url) {
    const line = mine.status === 'sold' ? t('ticket.line.sold')
      : mine.status === 'paid' ? t('ticket.line.paid')
      : mine.status === 'link_sent' || mine.status === 'ordered' ? t('ticket.line.link')
        : opened ? t('ticket.line.since', { date: opened }) : '';
    return { action: 'go', url: mine.url, badge: DEAL_STATUS[mine.status] ?? DEAL_STATUS.open, line };
  }
  // Sans ticket : aucune explication. Seule exception, l'ajout au serveur à la connexion (GET /features → join) : un
  // effet de la connexion que le visiteur doit connaître avant de cliquer (l'écran de Discord le redit).
  if (!signedIn && join) return { action: 'open', badge: null, line: t('ticket.line.join') };
  return { action: 'open', badge: null, line: '' };
}

/**
 * Blocs de la fiche selon le rôle lu sur /me : ticket client (toujours), panneau de l'équipe, entrée discrète de l'équipe.
 * Panneau : administrateur (features.payments) ou staff avec les tickets actifs (MiddleMan : actions de ticket sans
 * paiement) ; GET /tickets reste juge (403 : panneau retiré).
 */
export function roleBlocks(rights, { signedIn = false, wantedTicket = '' } = {}) {
  return {
    ticket: true,
    admin: Boolean(signedIn && (rights?.payments || (rights?.team && rights?.tickets))),
    teamLogin: Boolean(!signedIn && wantedTicket && TICKET.test(wantedTicket)),
  };
}

/**
 * Montant saisi (« 150 », « 150,5 », « 1 200,00 ») → « 150.50 », en centimes entiers ; null si illisible, nul ou au-delà
 * de `max` unités. Même règle que le service (qui revalide).
 */
export function parseAmount(raw, max) {
  const text = String(raw ?? '').trim().replace(/[\s  ]/g, '');
  const match = /^(\d{1,6})(?:[.,](\d{1,2}))?$/.exec(text);
  if (!match) return null;
  const cents = Number(match[1]) * 100 + Number((match[2] ?? '').padEnd(2, '0'));
  if (cents <= 0 || !Number.isFinite(max) || cents > max * 100) return null;
  return `${Math.floor(cents / 100)}.${String(cents % 100).padStart(2, '0')}`;
}

/** « 150.50 » + « EUR » → « 150,50 € » (français) ; devise illisible → montant suivi du code. */
export function formatMoney(amount, currency) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '';
  try { return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: /^[A-Z]{3}$/.test(currency || '') ? currency : 'EUR' }).format(value); }
  catch { return `${value.toFixed(2).replace('.', ',')} ${currency || ''}`.trim(); }
}

/** Dossier présélectionné : celui de ?ticket= s'il est listé, sinon le premier non payé, sinon le premier. */
export function pickTicket(tickets, wanted) {
  const list = Array.isArray(tickets) ? tickets : [];
  if (wanted && list.some((item) => item.ticket === wanted)) return wanted;
  return (list.find((item) => !SETTLED.has(item.status)) ?? list[0])?.ticket ?? '';
}

/** Lien payable en cours d'un dossier (le plus récent au statut « open »), ou null. */
export const openLink = (ticket) => (Array.isArray(ticket?.payments) ? ticket.payments.find((entry) => entry.status === 'open') ?? null : null);

/** Centimes entiers → montant français (1000 → « 10,00 € ») par découpage des chiffres, sans calcul ; '' si illisible. */
const minorMoney = (minor, currency) => (Number.isSafeInteger(minor) && minor > 0
  ? formatMoney(`${String(minor).padStart(3, '0').slice(0, -2)}.${String(minor).padStart(3, '0').slice(-2)}`, currency) : '');

/** Réponse de POST /payment-links → { kind, message, … }. kind : created | conflict | paid | invalid | auth | forbidden | error. */
export function paymentOutcome(status, body, currency = 'EUR') {
  const data = body && typeof body === 'object' ? body : {};
  const code = typeof data.error === 'string' ? data.error : '';
  if (status === 201) {
    const url = invoiceUrl(data.invoiceUrl);
    if (!url) return { kind: 'error', message: 'Réponse inattendue du service : vérifiez la commande provisoire dans Shopify.' };
    const shown = formatMoney(data.total || data.amount, data.currency || currency);
    /* Annonce avec prix (C8) : réduction accordée à cet acheteur, déjà déduite par le service. */
    const discount = minorMoney(data.discountMinor, data.currency || currency);
    return {
      kind: 'created', url, posted: data.posted === true, name: String(data.draftOrder?.name ?? ''), adminUrl: adminUrl(data.draftOrder?.adminUrl),
      message: `Lien ${String(data.draftOrder?.name ?? '')} créé : ${shown}${discount ? ` (réduction de ${discount} incluse)` : ''}. ${data.posted === true ? 'Il est posté dans le ticket.' : 'Il n’a pas pu être posté dans le ticket : copiez-le et envoyez-le.'}`
    };
  }
  /* Annonce avec prix (C8, contrat prix § 5.5) : montant imposé, jamais saisi. */
  if (status === 409 && code === 'price_required') return { kind: 'invalid', message: 'Cette annonce n’a pas encore de prix : fixez-le avant de créer un lien.' };
  if (status === 409 && code === 'price_mismatch') return { kind: 'invalid', message: 'Le prix de l’annonce ne correspond plus à l’accord du vendeur : actualisez le dossier. Aucun lien n’a été créé.' };
  if (status === 409 && code === 'seller_price_mismatch') return { kind: 'invalid', message: 'Le prix ne correspond plus à l’accord du registre vendeur : actualisez le dossier. Aucun lien n’a été créé.' };
  if (status === 409 && code === 'price_above_payment_max') return { kind: 'invalid', message: 'Ce prix dépasse le maximum des paiements : aucun lien n’a été créé.' };
  if (status === 503 && code === 'link_product_missing') return { kind: 'error', message: 'Le produit de paiement de ce compte manque dans Shopify : aucun lien n’a été créé.' };
  if ((status === 409 || status === 422) && (/^discount_/.test(code) || code === 'invalid_discount')) return { kind: 'invalid', message: 'La réduction de cet acheteur n’est plus valable : actualisez le dossier. Aucun lien n’a été créé.' };
  if (status === 409 && code === 'open_link_exists') {
    const name = String(data.draftOrderName ?? '');
    return {
      kind: 'conflict', name, mine: data.mine === true,
      message: data.mine === true
        ? `Ce ticket a déjà un lien ouvert (${name}). Le remplacer supprime l’ancien lien dans Shopify : il ne pourra plus être payé.`
        : `Un lien ouvert (${name}) existe déjà pour cette annonce dans un autre ticket. Un seul lien payable par annonce : le remplacer supprime l’ancien dans Shopify.`
    };
  }
  if (status === 409 && code === 'already_paid') return { kind: 'paid', message: 'Cette annonce a déjà été payée : aucun nouveau lien n’a été créé.' };
  if (status === 409 && code === 'listing_paid') return { kind: 'paid', message: 'Cette annonce a déjà été payée : retirez-la ou clôturez le dossier payé avant d’envoyer un autre lien.' };
  if (status === 409 && code === 'listing_unavailable') return { kind: 'paid', message: 'Cette annonce n’est plus disponible (retirée ou vendue) : aucun lien n’a été créé.' };
  if (status === 409 && code === 'listing_not_ticketable') return { kind: 'paid', message: 'Annonce d’exemple, pas à vendre : aucun lien n’a été créé.' };
  if (status === 409 && code === 'ticket_closed') return { kind: 'paid', message: 'Ce ticket est clos : aucun lien n’a été créé.' };
  if (status === 422 && code === 'invalid_amount') return { kind: 'invalid', message: 'Montant refusé par le service : vérifiez la valeur et le maximum.' };
  if (status === 401) return { kind: 'auth', message: 'Votre connexion Discord a expiré : reconnectez-vous pour créer le lien.' };
  if (status === 403) return { kind: 'forbidden', message: 'Ce compte n’a pas le droit de créer un lien de paiement.' };
  if (status === 429) return { kind: 'error', message: 'Une opération est déjà en cours pour cette annonce : réessayez dans quelques secondes.' };
  if (status === 503 && code === 'payments_disabled') return { kind: 'error', message: 'Les liens de paiement ne sont pas encore activés sur le service.' };
  return { kind: 'error', message: 'Le lien n’a pas pu être créé pour le moment. Réessayez dans quelques minutes.' };
}

/** Texte court venu du service (nom, message) : sans caractères de contrôle, borné ; affiché par textContent seulement. */
const plain = (value, max = 80) => (typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max) : '');
/** Personne { id, name } du service (ou nom seul, forme d'avant les actions) → nom affichable, sinon ''. */
const personName = (value) => plain(typeof value === 'string' ? value : value?.name, 64);

/**
 * Dossier de GET /tickets ou de POST /tickets/actions → dossier lisible par le panneau, ou null (identifiant illisible).
 * Garde les champs de paiement (payments, order) ; `actions` vaut null si le service ne les envoie pas (version d'avant
 * les actions de ticket : seul le paiement de l'administrateur est alors proposé).
 */
export function readDeal(item) {
  if (!item || typeof item !== 'object' || !TICKET.test(item.ticket ?? '')) return null;
  const raw = item.link && typeof item.link === 'object' ? item.link : null;
  const link = raw && (typeof raw.amount === 'string' || typeof raw.amount === 'number')
    ? { name: plain(raw.name, 20), amount: String(raw.amount), status: LINK_STATUS[raw.status] ? raw.status : '', currency: /^[A-Z]{3}$/.test(raw.currency || '') ? raw.currency : '' } : null;
  const event = item.lastEvent && typeof item.lastEvent === 'object' && typeof item.lastEvent.action === 'string' ? item.lastEvent : null;
  return {
    ...item,
    status: DEAL_STATUS[item.status] ? item.status : 'open',
    location: LOCATION[item.location] ? item.location : null,
    buyer: personName(item.buyer) || 'Acheteur',
    claimedBy: personName(item.claimedBy),
    link,
    lastEvent: event ? { action: /^[a-z_]{1,32}$/.test(event.action) ? event.action : '', by: personName(event.by), at: typeof event.at === 'string' ? event.at : '' } : null,
    actions: Array.isArray(item.actions) ? [...new Set(item.actions.filter((name) => typeof name === 'string'))] : null,
    updatedAt: typeof item.updatedAt === 'string' && item.updatedAt.length <= 40 ? item.updatedAt : null,
  };
}

/**
 * Boutons d'un dossier, groupés et ordonnés : { ticket: [...], sale: [...], pay: { create, cancel } }. Seules les actions
 * de `deal.actions` apparaissent, dans l'ordre de TICKET_ACTIONS ; une action inconnue est ignorée. Sans `actions`
 * (service d'avant les actions), le paiement suit le droit de l'administrateur (`payments`) et l'état du dossier.
 */
export function actionGroups(deal, { payments = false } = {}) {
  const groups = { ticket: [], sale: [], pay: { create: false, cancel: false } };
  if (!deal) return groups;
  if (!Array.isArray(deal.actions)) {
    groups.pay = { create: Boolean(payments && !SETTLED.has(deal.status)), cancel: Boolean(payments) };
    return groups;
  }
  const allowed = new Set(deal.actions);
  for (const [name, spec] of Object.entries(TICKET_ACTIONS)) if (allowed.has(name)) groups[spec.group].push(name);
  groups.pay = { create: allowed.has(PAYMENT_ACTIONS.create), cancel: allowed.has(PAYMENT_ACTIONS.cancel) };
  return groups;
}

/** Dernier événement → « Pris en charge par Admin · 07/10/2026 14:02 » (action inconnue : « Mis à jour »), ou ''. */
export function eventText(event) {
  if (!event) return '';
  const what = EVENT_LABELS[event.action] ?? 'Mis à jour';
  const when = formatDate(event.at);
  return `${what}${event.by ? ` par ${event.by}` : ''}${when ? ` · ${when}` : ''}`;
}

/** Dernier lien de paiement du dossier (résumé) → « #D1 · 150,00 € · Ouvert » (nom et état s'ils sont connus), ou ''. */
export function linkText(link, currency = 'EUR') {
  if (!link) return '';
  const amount = formatMoney(link.amount, link.currency || currency);
  return amount ? [link.name, amount, LINK_STATUS[link.status]?.label].filter(Boolean).join(' · ') : '';
}

/** Saisie de confirmation d'une suppression : exactement SUPPRIMER (espaces autour tolérés). */
export const deleteConfirmed = (text) => String(text ?? '').normalize('NFC').trim() === DELETE_WORD;

/**
 * Corps de POST /tickets/actions pour le dossier affiché : confirmation jointe pour la suppression (mot saisi) et la
 * conclusion (true) ; `updatedAt` du dossier affiché, pour que le service refuse (conflit) une action décidée sur un
 * état dépassé.
 */
export function actionBody(deal, action, typed = '') {
  const body = { ticket: deal.ticket, action, ...(deal.updatedAt ? { updatedAt: deal.updatedAt } : {}) };
  if (action === 'delete') return { ...body, confirm: String(typed).trim() };
  if (action === 'conclude') return { ...body, confirm: true };
  return body;
}

const ACTION_KINDS = new Set(['done', 'forbidden', 'invalid', 'conflict', 'error']);
const ACTION_DEFAULTS = Object.freeze({
  done: 'C’est fait.',
  forbidden: 'Ce compte n’a pas le droit de faire cette action.',
  invalid: 'Action refusée par le service : vérifiez la saisie.',
  conflict: 'Le ticket a changé entre-temps, sans doute depuis Discord : voici son état à jour.',
  error: 'L’action n’a pas abouti. Réessayez dans quelques instants.',
  auth: 'Votre connexion Discord a expiré : reconnectez-vous.',
});

/**
 * Réponse de POST /tickets/actions → { kind, message, deal }. kind : done | forbidden | invalid | conflict | error | auth
 * (401). Le `kind` du service prime ; à défaut, il se déduit du code HTTP. `deal` : dossier à jour (readDeal) ou null ;
 * un `done` sans dossier lisible demande une relecture.
 */
export function actionOutcome(status, body) {
  const data = body && typeof body === 'object' ? body : {};
  let kind = ACTION_KINDS.has(data.kind) ? data.kind
    : status >= 200 && status < 300 ? 'done' : status === 403 ? 'forbidden' : status === 409 ? 'conflict' : status === 400 || status === 422 ? 'invalid' : 'error';
  if (status === 401) kind = 'auth';
  if (kind === 'done' && (status < 200 || status >= 300)) kind = 'error';
  /* Erreurs génériques du service, au format { error } : limite par minute, interrupteur coupé. */
  const generic = status === 429 ? 'Trop d’actions en peu de temps : patientez un instant, puis réessayez.'
    : status === 503 && data.error === 'tickets_disabled' ? 'Les actions de ticket ne sont pas activées sur le service.' : '';
  return { kind, message: plain(data.message, 300) || generic || ACTION_DEFAULTS[kind], deal: readDeal(data.deal) };
}

/* ------------------------------------------------------------------ interface */

const external = () => h('span', { class: 'fs-visually-hidden', text: ` (${t('account.new_tab')})` });
const arrow = () => h('span', { class: 'fs-link-icon', 'aria-hidden': 'true', text: '↗' });
/** Logo Discord (masque CSS de fs-components.css), décoratif. */
const discordIcon = () => h('span', { class: 'fs-discord-icon', 'aria-hidden': 'true' });
/** Badge d'état du catalogue (fs-ui-feedback.css) : tons du ticket (ok, warn…) relus en tons du catalogue. */
const BADGE_TONES = Object.freeze({ ok: 'success', warn: 'warning', danger: 'danger', accent: 'accent', muted: 'neutral' });
const badge = (status) => h('span', { class: 'fs-badge fs-tk-badge', 'data-tone': BADGE_TONES[status.tone] || null, text: status.label });
/** Lien sortant (fs-link par défaut) : trait sous le libellé seul (.fs-link-text), pictogramme et ↗ hors du trait. */
const linkTo = (href, text, className = 'fs-link', icon = null) => {
  icon?.classList.add('fs-link-icon');
  return h('a', { class: className, href, target: '_blank', rel: 'noopener noreferrer' }, icon, h('span', { class: 'fs-link-text', text }), external(), arrow());
};
let sequence = 0;

const tabStore = {
  get(key) { try { return window.sessionStorage.getItem(key); } catch { return null; } },
  set(key, value) { try { window.sessionStorage.setItem(key, value); } catch { /* indisponible */ } },
};

function initialise(root) {
  if (root.dataset.fsTicketsReady) return;
  const account = window.FSAccount;
  const service = serviceBase(root.dataset.fsTickets);
  /* fs-account.js (chargé avant) porte la session : sans lui, aucune demande possible ; la fiche le dit (phrase
     [data-fs-ld-nolink], rendue masquée quand les tickets sont actifs). */
  if (!service || !account || account.service !== service) {
    const reveal = (scope) => scope.querySelectorAll('[data-fs-ld-nolink]').forEach((node) => { node.hidden = false; });
    reveal(root);
    root.querySelectorAll('[data-fs-detail]').forEach((slot) => new MutationObserver(() => reveal(slot)).observe(slot, { childList: true }));
    return;
  }
  root.dataset.fsTicketsReady = 'true';
  const invite = inviteUrl(root.dataset.fsDiscordInvite);
  let wantedTicket = (() => { const value = new URLSearchParams(window.location.search).get('ticket') || ''; return TICKET.test(value) ? value : ''; })();
  const views = new Set();
  let pending = null; // intention « ticket » revenue de Discord, en attente de sa fiche
  let mine = { token: '', at: 0, promise: null };
  /* Ajout au serveur à la connexion (GET /features → join, public) : cache d'onglet de 5 min, relu à chaque rendu ; la
     promesse ne couvre que la lecture en cours. Faux si illisible (la ligne d'aujourd'hui reste). */
  let join = readJoinCache(tabStore.get(JOIN_KEY)) === true, joinPromise = null;
  function joinOnLogin() {
    joinPromise ??= (async () => {
      const cached = readJoinCache(tabStore.get(JOIN_KEY));
      if (cached !== null) return (join = cached);
      try {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 10000);
        const response = await fetch(`${service}/features`, { mode: 'cors', credentials: 'omit', signal: controller.signal }).finally(() => clearTimeout(timer));
        join = response.ok && (await response.json().catch(() => null))?.join === true;
        if (response.ok) tabStore.set(JOIN_KEY, JSON.stringify({ at: Date.now(), join }));
      } catch { join = false; }
      return join;
    })().finally(() => { joinPromise = null; });
    return joinPromise;
  }

  /** Mes tickets (toutes annonces), lus une fois par minute et par session : une lecture pour toutes les fiches. */
  function myTickets() {
    const active = account.session();
    if (!active) return Promise.resolve(null);
    if (mine.promise && mine.token === active.token && Date.now() - mine.at < MINE_TTL_MS) return mine.promise;
    const promise = account.call('/tickets/mine').then(({ status, body }) => (status === 200 ? body : null), () => null);
    mine = { token: active.token, at: Date.now(), promise };
    return promise;
  }

  function login(kind, view, message) {
    const url = account.prepareLogin({ kind, game: view.game, listing: view.listing, ticket: wantedTicket });
    if (!url) {
      view.fail({ message: t('ticket.auth.storage') });
      return;
    }
    view.say(message || t('ticket.auth.connecting'));
    window.location.assign(url);
  }

  /* ---------------------------------------------------------------- fiche */
  function enhance(detail) {
    const slot = detail.querySelector('[data-fs-ticket-slot]');
    const commerce = detail.querySelector('[data-fs-commerce]');
    const listing = slot?.dataset.fsTicketListing || '';
    /* Annonce d'exemple : rien n'est monté (ni ticket, ni ligne d'état, ni panneau). Jeu hors des tickets
       (ticketGameOpen : DarkOrbit tant que fs_darkorbit_live est fermé) : aucune action de ticket, une ligne d'état. */
    if (!slot || !commerce || isSample(detail) || !HANDLE.test(listing) || detail.dataset.fsTicketReady) return;
    detail.dataset.fsTicketReady = 'true';
    const game = slot.dataset.fsTicketGame || '';
    const supported = ticketable(detail, slot);
    const id = `fs-tk-${++sequence}`;
    /* Phrase « demande indisponible » du Liquid : remplacée par l'action ou la ligne d'état. */
    const nolink = commerce.querySelector('[data-fs-ld-nolink]');
    nolink?.setAttribute('hidden', '');

    const line = h('p', { class: 'fs-tk-line', id: `${id}-line`, role: 'status', 'data-fs-ticket-status': true });
    const alert = h('div', { class: 'fs-alert fs-tk-alert', 'data-tone': 'danger', role: 'alert', 'data-fs-ticket-error': true, hidden: true });
    slot.replaceChildren(line, alert);
    slot.hidden = false;
    /* Ligne vide (aucun ticket, aucun message) : aucun enfant, la ligne disparaît (.fs-tk-line:empty). */
    const setLine = (state) => line.replaceChildren(...(state.badge ? [badge(state.badge), ' '] : []), ...(state.line ? [h('span', { class: 'fs-tk-line-text', text: state.line })] : []));
    const view = {
      detail, listing, game, busy: false, stamp: 0,
      say(text) { alert.hidden = true; line.replaceChildren(h('span', { class: 'fs-tk-line-text', text })); },
      fail() {}, render() {}, openTicket() {},
    };
    views.add(view);
    /* Jeu hors des tickets (ticketGameOpen) : aucune action de ticket, une ligne le dit ; l'équipe arrivée par
       ?ticket= garde son lien vers l'espace équipe, jamais un panneau sur la fiche. */
    if (!supported) { setLine(commerceState({ supported: false })); setupAdmin(view); return view; }

    /* Achat direct présent (bouton, ou « Indisponible pour le moment ») : l'achat reste l'action principale, le ticket
       passe dessous, en secondaire, hors de la bande collante du téléphone. Sinon, action principale de la zone commerce. */
    const buyFirst = Boolean(commerce.querySelector('[data-fs-purchase], [data-fs-purchase-off]'));
    const tone = buyFirst ? 'fs-btn fs-btn--lg fs-ld-cta' : 'fs-btn fs-btn--primary fs-btn--lg fs-ld-cta';
    const open = h('button', { type: 'button', class: `${tone} fs-tk-open`, 'data-fs-ticket-open': true, 'aria-describedby': `${id}-line` }, discordIcon(), t('ticket.action.open'));
    const goLabel = h('span', { text: t('ticket.action.go') });
    const go = h('a', { class: `${tone} fs-tk-go`, href: '#', target: '_blank', rel: 'noopener noreferrer', 'data-fs-ticket-go': true, hidden: true, 'aria-describedby': `${id}-line` },
      discordIcon(), goLabel, ' ', arrow(), external());
    commerce.classList.remove('fs-ld-commerce--nolink');
    if (buyFirst) commerce.after(h('div', { class: 'fs-ld-ask', 'data-fs-ticket-actions': true }, open, go));
    else commerce.append(open, go);
    const act = (state) => {
      const { action } = state;
      open.hidden = action !== 'open';
      go.hidden = action !== 'go' && action !== 'read';
      goLabel.textContent = t(action === 'read' ? 'ticket.action.read' : 'ticket.action.go');
      if (!go.hidden) go.href = state.url;
      setLine(state);
    };

    Object.assign(view, {
      fail({ message, member = false, restricted = false }) {
        alert.replaceChildren(h('p', { text: message }));
        const links = [];
        if (member && !restricted && invite) links.push(linkTo(invite, t('ticket.action.join'), undefined, discordIcon()));
        if (links.length) alert.append(h('p', { class: 'fs-tk-alert-links' }, links));
        alert.hidden = false;
      },
      /** État de la zone commerce : session, puis mon ticket pour cette annonce. Une lecture dépassée (ticket ouvert ou
          autre rendu entre-temps) n'écrase jamais l'état affiché. */
      async render() {
        const stamp = ++view.stamp;
        if (!account.session()) {
          // Ligne tout de suite, puis complétée si le service annonce l'ajout au serveur (une lecture par page).
          act(commerceState({ signedIn: false, join }));
          if (!(await joinOnLogin()) || !detail.isConnected || view.busy || stamp !== view.stamp || account.session()) return;
          act(commerceState({ signedIn: false, join: true }));
          return;
        }
        const body = await myTickets();
        if (!detail.isConnected || view.busy || stamp !== view.stamp) return;
        if (!account.session()) { act(commerceState({ signedIn: false, join })); return; }
        act(commerceState({ signedIn: true, mine: myTicketFor(body, listing) }));
      },
      async openTicket() {
        if (view.busy) return;
        if (!account.session()) { login('ticket', view, t('ticket.auth.connecting')); return; }
        view.stamp += 1;
        view.busy = true;
        open.setAttribute('aria-busy', 'true');
        open.disabled = true;
        view.say(t('ticket.action.opening'));
        let outcome;
        try {
          const { status: code, body } = await account.call('/tickets', { method: 'POST', body: { listing } });
          outcome = ticketOutcome(code, body);
        } catch { outcome = { kind: 'error', message: t('account.error.service') }; }
        view.busy = false;
        open.removeAttribute('aria-busy');
        open.disabled = false;
        if (outcome.kind === 'opened' || outcome.kind === 'existing') {
          mine = { token: '', at: 0, promise: null };
          act({ action: 'go', url: outcome.url, badge: DEAL_STATUS.open, line: outcome.message });
          // Panneau de l'équipe de la même fiche : relire les dossiers (sinon « Aucun ticket » jusqu'au retour sur l'onglet).
          detail.dispatchEvent(new CustomEvent(TICKET_OPENED_EVENT));
          if (detail.isConnected) go.focus({ preventScroll: true });
          return;
        }
        if (outcome.kind === 'auth') { login('ticket', view, outcome.message); return; }
        if (outcome.kind === 'closed') { act(commerceState({ signedIn: true, mine: { status: 'closed' } })); return; }
        await view.render();
        view.fail({ message: outcome.message, member: outcome.kind === 'member', restricted: outcome.restricted });
      },
    });
    open.addEventListener('click', () => view.openTicket());
    act(commerceState({ signedIn: Boolean(account.session()), join }));
    view.render();
    setupAdmin(view);
    if (pending && pending.listing === listing) consume(view);
    return view;
  }

  /* ---------------------------------------------------------------- équipe */
  /** Rien pour l'équipe sur la fiche (demande de Charles, 9 octobre 2026), sauf arrivée par le lien ?ticket= de la carte de
      suivi Discord : « Gérer dans l'espace équipe », ou la connexion de l'équipe sans session. */
  async function setupAdmin(view) {
    const slot = view.detail.querySelector('[data-fs-ticket-admin]');
    if (!slot || isSample(view.detail)) return;
    if (!wantedTicket) { slot.replaceChildren(); slot.hidden = true; return; }
    const rights = account.session() ? await account.me() : null;
    if (!view.detail.isConnected) return;
    const blocks = roleBlocks(rights, { signedIn: Boolean(account.session()), wantedTicket });
    if (rights?.team) {
      const query = new URLSearchParams(ticketGameOpen(view.game) ? { ecran: 'tickets', listing: view.listing, ...(wantedTicket ? { ticket: wantedTicket } : {}) } : { ecran: 'catalogue', handle: view.listing });
      slot.replaceChildren(h('a', { class: 'fs-btn fs-btn--link', href: path(`pages/moderation?${query}`), 'data-fs-admin-entry': true }, t('ticket.action.manage')));
      slot.hidden = false;
      return;
    }
    if (blocks.teamLogin) {
      /* Lien du ticket (?ticket=) sans session : entrée discrète pour l'équipe, rien d'autre. */
      slot.replaceChildren(h('p', { class: 'fs-tk-team' }, h('button', { type: 'button', class: 'fs-btn fs-btn--link fs-tk-team-login', onclick: () => login('admin', view, t('ticket.auth.connecting')) }, discordIcon(), h('span', { class: 'fs-link-text', text: t('ticket.action.team_login') }))));
      slot.hidden = false;
      return;
    }
    slot.replaceChildren();
    slot.hidden = true;
  }

  /* ---------------------------------------------------------------- retour de Discord */
  /** Intention « ticket » revenue de Discord : appliquée à sa fiche (rouverte par ?listing= ou page de l'annonce). */
  function consume(view) {
    const intent = pending;
    pending = null;
    if (!intent) return;
    if (!intent.ok) {
      view.fail({ message: authReturnMessage(intent.error), member: /member/.test(intent.error || ''), restricted: /restricted/.test(intent.error || '') });
      return;
    }
    if (intent.kind === 'ticket') view.openTicket();
  }

  /** Issue de la connexion (fs-account.js) : dossier gardé pour l'équipe, ticket ouvert pour le client, erreur affichée. */
  function onOutcome(detail) {
    const intent = detail?.intent;
    if (intent?.ticket && !wantedTicket) wantedTicket = intent.ticket;
    views.forEach((view) => { if (!view.detail.isConnected) views.delete(view); });
    if (!intent || !['ticket', 'admin'].includes(intent.kind) || !intent.listing) return;
    if (intent.kind === 'admin' && detail.ok) { views.forEach((view) => setupAdmin(view)); return; }
    pending = { ...intent, ok: detail.ok === true, error: typeof detail.error === 'string' ? detail.error : '' };
    const view = [...views].find((item) => item.listing === intent.listing);
    if (view) consume(view);
  }
  if (account.returning) account.returning.promise.then(onOutcome);

  /* Connexion, déconnexion ou expiration (ici, dans l'en-tête ou dans un autre onglet) : blocs recalculés. */
  document.addEventListener('fs:account', () => {
    mine = { token: '', at: 0, promise: null };
    views.forEach((view) => {
      if (!view.detail.isConnected) { views.delete(view); return; }
      view.render();
      setupAdmin(view);
    });
  });

  /* Fiches insérées dans [data-fs-detail] (clonées à chaque ouverture sur l'accueil, présentes d'emblée sur la page). */
  const scan = (node) => {
    if (node.nodeType !== 1) return;
    if (node.matches('[data-fs-ld]')) enhance(node);
    node.querySelectorAll('[data-fs-ld]').forEach(enhance);
  };
  const observer = new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach(scan)));
  root.querySelectorAll('[data-fs-detail]').forEach((slot) => { observer.observe(slot, { childList: true }); scan(slot); });
}

if (typeof document !== 'undefined') {
  document.querySelectorAll('[data-fs-tickets]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-fs-tickets]').forEach(initialise));
}
